var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FieldEditorService } from '@/presentation/components/field-editor/field-editor-service.interface';
let LayerFieldInfoServiceImp = class LayerFieldInfoServiceImp {
    constructor(_fieldEditorService) {
        this._fieldEditorService = _fieldEditorService;
    }
    getLayerFieldInfo() {
        const { field } = this._fieldEditorService;
        const { field_id: fieldId, field_name: fieldName, field_color: fieldColor, field_label_scope: fieldLabelScope, edit_definition: editDefinition, } = field;
        return { fieldId, fieldName, fieldColor, fieldLabelScope, editDefinition };
    }
};
LayerFieldInfoServiceImp = __decorate([
    injectable(),
    __param(0, inject(FieldEditorService)),
    __metadata("design:paramtypes", [typeof (_a = typeof FieldEditorService !== "undefined" && FieldEditorService) === "function" ? _a : Object])
], LayerFieldInfoServiceImp);
export { LayerFieldInfoServiceImp };
